import type { CliE2eeRuntime } from '../../../../lib/e2ee/index.js';
import { formatCliE2eeDecryptError } from '../../../../lib/e2ee/decrypt-stored-e2ee-content.js';
import { decryptParentPromptTurns } from './decrypt-parent-prompt-turns.js';
import { fetchInternalApiJson } from './internal-api.js';
import type { CloudFetchParams, ParentPromptsJson } from './types.js';

export async function fetchCloudParentSessionPrompts(
  params: CloudFetchParams & { childSessionId: string; e2ee?: CliE2eeRuntime },
): Promise<{ ok: true; data: ParentPromptsJson } | { ok: false; error: string }> {
  const fetched = await fetchInternalApiJson<ParentPromptsJson>({
    ...params,
    path: `/internal/sessions/${encodeURIComponent(params.childSessionId)}/parent/prompts`,
    errorLabel: 'Parent prompts fetch failed',
  });
  if (!fetched.ok) return fetched;
  const turns = Array.isArray(fetched.data.turns) ? fetched.data.turns : [];
  try {
    const decryptedTurns = decryptParentPromptTurns(turns, params.e2ee);
    return { ok: true, data: { ...fetched.data, turns: decryptedTurns } };
  } catch (error) {
    return { ok: false, error: formatCliE2eeDecryptError(error, params.e2ee) };
  }
}
